import { withFormik } from 'formik'
import React, { useEffect } from 'react'
import Button from '../../../Components/Button'
import Field from '../../../Components/Formik/Field'
import Form from '../../../Components/Formik/Form'

function SalesQuotationFilter({ values, setValues, filterData }) {
  useEffect(() => {
    setValues({ ...values, ...filterData })
  }, [])

  return (
    <Form>
      <div className="form-fields">
        <Field name="quotationNo" label="Quotation No" />
      </div>
      <div className="form-fields">
        <Field name="clientName" label="Customer Name" />
      </div>
      <div className="form-fields">
        <Field as="date" name="quotationDate" label="Quotation Date" />
      </div>
      <div className="form-fields">
        <Button type="submit" variant="secondary" className="search">
          <i className="flaticon-search-interface-symbol" />
          Search
        </Button>
        <Button type="reset" className="btn-block btn-glow search">
          Clear
        </Button>
      </div>
    </Form>
  )
}

export default withFormik({
  mapPropsToValues: () => ({
    quotationNo: '',
    quotationDate: '',
    clientName: ''
  }),
  handleSubmit: (values, { props: { onSubmit } }) => onSubmit(values)
})(SalesQuotationFilter)
